export const formatDate = (date: Date) => date.toISOString();

const MINUTE = 60,
    HOUR = MINUTE * 60,
    DAY = HOUR * 24,
    YEAR = DAY * 365;

export function getTimeAgo(date: Date) {
    const secondsAgo = Math.floor((new Date().getTime() - date.getTime()) / 1000);

    if (secondsAgo < MINUTE) {
        return secondsAgo + 's';
    } else if (secondsAgo < HOUR) {
        return Math.floor(secondsAgo / MINUTE) + 'm';
    } else if (secondsAgo < DAY) {
        return Math.floor(secondsAgo / HOUR) + 'h';
    } else if (secondsAgo < YEAR) {
        return date.toLocaleString('default', { day: 'numeric', month: 'short' });
    } else {
        return date.toLocaleString('default', { year: 'numeric', month: 'short' });
    }
}

export function formatDatePretty(date?: Date | number, defaultValue: string = 'N/A') {
    if (!date) {
        return defaultValue;
    }

    if (typeof date === 'number') {
        date = new Date(date);
    }

    return date.toLocaleString('en-US', {
        month: 'long',
        year: 'numeric',
    });
}
